import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getFirstFlow = asyncThunkWrapper({ 
  model: 'firstFlows', 
  action: 'getFirstFlow', 
  func: async () => {
    const params = { attributes: ['id', 'phone', 'email', 'prompt', 'updated_at'] };
    const response = await axios.get(`/first_flow`, { params });

    return response.data;
  } 
});
export const createFirstFlow = asyncThunkWrapper({ 
  model: 'firstFlows', 
  action: 'createFirstFlow', 
  func: async (first_flow) => {
    const attributes = ['id', 'phone', 'email', 'prompt', 'updated_at'];
    const response = await axios.post(`/first_flow`, { first_flow, attributes });

    return response.data;
  } 
});
export const updateFirstFlow = asyncThunkWrapper({ 
  model: 'firstFlows', 
  action: 'updateFirstFlow', 
  func: async (first_flow) => {
    const response = await axios.patch(`/first_flow`, { first_flow });

    return { status: response.status, first_flow };
  } 
});
export const deleteFirstFlow = asyncThunkWrapper({ 
  model: 'firstFlows', 
  action: 'deleteFirstFlow', 
  func: async () => {
    const response = await axios.delete(`/first_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveFirstFlow = createAction('firstFlows/clearLocalActiveFirstFlow');